
import React, { useEffect, useState } from "react";
import "./SideBar.css";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import ListAltIcon from "@mui/icons-material/ListAlt";
import DescriptionIcon from "@mui/icons-material/Description";
import Circle from "@mui/icons-material/Circle";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import MenuIcon from "@mui/icons-material/Menu";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import LogoutIcon from "@mui/icons-material/Logout";
import { ReactComponent as BtLogo } from "../images/btLogo.svg";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import DragIndicatorSharpIcon from '@mui/icons-material/DragIndicatorSharp';

import { Button } from "@mui/material";
import { useNavigate } from "react-router";

const SideBar = () => {
  const [expand, setExpand] = useState(false);
  const [showMenu, setShowMenu] = useState(true);
  const userRoles = JSON.parse(localStorage.getItem("userRole"));
  const [higherRole, setHigherRole] = useState('');
  const [expandcategory, setExpandcategory] = useState(false);
  useEffect(() => {
    if (userRoles?.includes("TMS-UI-Admin")) {
      setHigherRole("TMS-UI-Admin");
    }
    else
    {
      setHigherRole('')
    }

    const expandState = JSON.parse(localStorage.getItem('expandstate'));
    if (expandState) {
        setExpand(expandState);
        localStorage.removeItem('expandState'); // Clear it after retrieving
        setExpandcategory(false)
    }

    const expandStateMaster = JSON.parse(localStorage.getItem('masterstate'));
    if (expandStateMaster) {
      setExpandcategory(expandStateMaster);
      localStorage.removeItem('masterstate'); // Clear it after retrieving
      setExpand(false)
  }

  }, []);

  useEffect(() => {
    const handleResize = () => {
        if (window.innerWidth <= 768) {
            setShowMenu(true); // Open the sidebar for small screens
        } else {
            setShowMenu(false); // Optionally close it for larger screens
        }
    };

    // Set initial state based on window size
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => {
        window.removeEventListener('resize', handleResize);
    };
}, []);
  
  const navigate = useNavigate();

  const handleClick = (e, page, state) =>{
    e.preventDefault();
    if (window.innerWidth <= 768) {
      setShowMenu(false); // Close the sidebar
  }
    localStorage.setItem(state , JSON.stringify(true));
     navigate(`/${page}`);
  }
  const toggleSidebar = () => {
    setShowMenu(!showMenu); // Toggle the sidebar visibility
};
  return (
    <div className="parent-bar">
      <div className="first_sidebar">
        <span onClick={() => navigate("/")}>
          <BtLogo className="btLogo" />
        </span>
        <div
          className="hamburger-menu"
          onClick={() => {
            setShowMenu(!showMenu);
          }}
        >
          {""}
          {showMenu ?  <MenuIcon /> : <CancelPresentationIcon />}
        </div>
      </div>
      <div className={`sidebar ${showMenu ? "" : "active"}`}>
        <div className={showMenu ? "main-menu new" : "new"}>
          <ul>
            <li>
              <span onClick={() => setExpand(!expand)} className="menu-item">
                <div className="menu-icon">
                  <div className={`dropdown ${expand ? "down" : ""}`}>
                    <KeyboardArrowRightIcon className="icon-bar" />
                  </div>
                </div>
                <span className="menu-text">Tickets</span>
              </span>
              <ul className={`sub-menu ${expand ? "active" : ""}`}>
              {higherRole === "TMS-UI-Admin" && (
                  <li>
                    <a
                      href="/tickets"
                      className="sub-menu-link"
                      onClick={(e) => handleClick(e,'tickets','expandstate')}
                    >
                      <ReceiptIcon className="icon-bar" />
                      <span className="menu-text">All Tickets</span>
                    </a>
                  </li>
              )}
                <li>
                  <a
                    href="/mytickets"
                    className="sub-menu-link"
                    onClick={(e) => handleClick(e,'mytickets', 'expandstate')}
                  >
                    <ReceiptIcon className="icon-bar" />
                    <span className="menu-text">My Tickets</span>
                  </a>
                </li>
              </ul>
            </li>

            {/* <li className="list-items">
                             <span className="menu-item" onClick={()=>{navigate("/incident")}} >
                           <div className="menu-icon">
                           <ListAltIcon className="icon-bar"/>
                           </div>
                           <span className="menu-text">
                              Incident Reporting
                           </span>
                           </span>
                           </li> */}
           {higherRole === "TMS-UI-Admin" && (
              <li className="list-items">
                <a
                  href="/users"
                  className="menu-item"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/users");
                  }}
                >
                  <div className="menu-icon">
                    <SupervisorAccountIcon className="icon-bar" />
                  </div>
                  <span className="menu-text">Users</span>
                </a>
              </li>
            )}
             {higherRole === "TMS-UI-Admin" && (
              <li className="list-items">
                <a
                  href="/report"
                  className="menu-item"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/report");
                  }}
                >
                  <div className="menu-icon">
                    <AutoGraphIcon className="icon-bar" />
                  </div>
                  <span className="menu-text">Report</span>
                </a>
              </li>
            )}
            <li className="list-items">
              <a
                href="/knowledge"
                className="menu-item"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/knowledge");
                }}
              >
                <div className="menu-icon">
                  <DescriptionIcon className="icon-bar" />
                </div>
                <span className="menu-text">Knowledge Base</span>
              </a>
            </li>
            {higherRole === "TMS-UI-Admin" && (
            <li className="list-items">
              <span
                onClick={() => setExpandcategory(!expandcategory)}
                className="menu-item"
              >
                <div className="menu-icon">
                  <div className={`dropdown ${expandcategory ? "down" : ""}`}>
                    <KeyboardArrowRightIcon className="icon-bar" />
                  </div>
                </div>
                <span className="menu-text">Master</span>
                </span>
                <ul className={`sub-menu ${expandcategory ? "active" : ""}`}>
               
                  <li>
                    <a
                      href="/category"
                      className="sub-menu-link"
                      onClick={(e) => handleClick(e,'category','masterstate')}
                    >
                      <DragIndicatorSharpIcon className="icon-bar" />
                      <span className="menu-text">Category</span>
                    </a>
                  </li>

                  <li>
                    <a
                      href="/subcategory"
                      className="sub-menu-link"
                      onClick={(e) => handleClick(e,'subcategory','masterstate')}
                    >
                      <DragIndicatorSharpIcon className="icon-bar" />
                      <span className="menu-text">SubCategory</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="/status"
                      className="sub-menu-link"
                      onClick={(e) => handleClick(e,'status','masterstate')}
                    >
                      <DragIndicatorSharpIcon className="icon-bar" />
                      <span className="menu-text">Status</span>
                    </a>
                  </li>
            
              </ul>
            </li>
               )}


            <li className="list-items">
              <a
                href="/myapproval"
                className="menu-item"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/myapproval");
                }}
              >
                <div className="menu-icon">
                  <Circle className="icon-bar" />
                </div>
                <span className="menu-text">My Approval</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
